import PendingApprovalsNotice from "../components/PendingApprovalsNotice";
import { GuideButton } from "../guides/GuideProvider";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Modal from "react-modal";

const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL;

function MyPage({ userRole, logout }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const newsUrl = "https://www.gymnastik.se/regioner/region-vast/ovriga-sidor/nyheter-vast";
  const [latestNews, setLatestNews] = useState({
    date: "",
    title: "Hämtar senaste nyhet..."
  });

  const menuItems = [
    { to: "/videos", label: "Videos" },
    { to: "/my-workouts", label: "Mina Träningspass" },
    { to: "/invitations", label: "Inbjudningar" },
    { to: "/usersettings", label: "Inställningar" }
  ];

  if ([1, 2, 4, 5].includes(userRole)) {
    menuItems.splice(2, 0, { to: "/my-groups", label: "Mina Grupper" });
  }

  if (userRole === 4) {
    menuItems.push({ to: "/user-management", label: "Min förenings konton" });
  }

  if (userRole === 1 || userRole === 2) {
    menuItems.push({ to: "/admin-dashboard", label: "Administration" });
  }

  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    let active = true;

    async function getLatestNews() {
      try {
        const response = await fetch(`${API_URL}/news/latest-region-vast`, {
          headers: {
            token: localStorage.getItem("token")
          }
        });

        if (!response.ok) {
          throw new Error("Failed to fetch latest news");
        }

        const data = await response.json();
        if (!active) return;

        setLatestNews({
          date: data.date || "",
          title: data.title || "Nyheter Väst"
        });
      } catch (error) {
        if (!active) return;

        setLatestNews({
          date: "",
          title: "Se senaste uppdateringarna hos Nyheter Väst"
        });
      }
    }

    getLatestNews();

    return () => {
      active = false;
    };
  }, []);

  return (
    <>
      <div className="flex flex-col items-center px-3">
        <div className="w-full max-w-5xl py-4">
          <div className="grid gap-5 lg:grid-cols-[minmax(0,1fr)_300px] lg:items-stretch">
            <div className="flex flex-col">
              <div className="theme-card mb-5">
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">
                  Meny
                </p>
                <p className="mt-2 text-sm text-slate-600">
                  Välj vad du vill göra. Snabbvalen nedan leder direkt till appens viktigaste delar.
                </p>
              </div>
              <PendingApprovalsNotice userRole={userRole} />
              <GuideButton id="overview" />
              <div className="space-y-4" data-guide="home-menu">
                {menuItems.map((item) => (
                  <Link data-guide={item.to === "/videos" ? "home-videos" : item.to === "/my-workouts" ? "home-workouts" : undefined} key={item.to} to={item.to} className="block">
                    <button className="theme-panel group relative flex w-full items-center justify-between overflow-hidden text-left hover:-translate-y-0.5 hover:border-sky-300 hover:shadow-md">
                      <span className="absolute inset-y-0 left-0 w-1.5 rounded-l-[24px] bg-gradient-to-b from-sky-500 to-cyan-400" />
                      <span className="pl-2 text-base font-semibold text-slate-800">
                        {item.label}
                      </span>
                      <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/80 text-sky-700 shadow-sm ring-1 ring-sky-100 transition-colors group-hover:bg-sky-100">
                        <svg
                          className="h-4 w-4"
                          viewBox="0 0 16 16"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                        >
                          <path d="M6 3.5L10.5 8L6 12.5L7.4 13.9L13.3 8L7.4 2.1L6 3.5Z" />
                        </svg>
                      </span>
                    </button>
                  </Link>
                ))}
              </div>
            </div>
            <aside className="hidden lg:block">
              <a
                href={newsUrl}
                target="_blank"
                rel="noreferrer"
                className="theme-card flex h-full flex-col hover:-translate-y-0.5 hover:border-sky-300 hover:shadow-md"
              >
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">
                  Region Väst
                </p>
                <h2 className="mt-2 text-lg font-bold text-slate-800">
                  Nyheter Väst
                </h2>
                <p className="mt-3 text-sm leading-6 text-slate-600">
                  Senaste nyheter och information från Svenska Gymnastikförbundet Region Väst.
                </p>
                <div className="theme-panel-muted mt-5 rounded-[22px] bg-white/85 p-4">
                  <p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
                    Senaste nyhet
                  </p>
                  {latestNews.date && (
                    <p className="mt-2 text-xs font-medium text-sky-700">
                      {latestNews.date}
                    </p>
                  )}
                  <p className="mt-2 text-sm font-semibold leading-6 text-slate-800">
                    {latestNews.title}
                  </p>
                </div>
                <div className="theme-panel mt-auto flex items-center justify-between rounded-[22px] bg-white/80 px-4 py-3">
                  <span className="text-sm font-semibold text-sky-700">
                    Öppna nyhetssidan
                  </span>
                  <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-sky-100 text-sky-700">
                    <svg
                      className="h-4 w-4"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path d="M6 3.5L10.5 8L6 12.5L7.4 13.9L13.3 8L7.4 2.1L6 3.5Z" />
                    </svg>
                  </span>
                </div>
              </a>
            </aside>
          </div>
          <div>
            <button className="theme-button-danger mt-5 flex w-full items-center justify-center hover:from-red-400 hover:to-rose-400" onClick={() => setModalIsOpen(true)}>Logga ut</button>
            <Modal className="fixed inset-0 flex items-center justify-center p-4" overlayClassName="fixed inset-0 bg-slate-900/35 backdrop-blur-[2px]" isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)}>
              <div className="theme-card max-w-sm p-5 shadow-lg">
                <p className="text-center text-xl font-semibold text-slate-800">Logga ut</p>
                <p className="p-4 text-center text-sm text-slate-600">Är du säker på att du vill logga ut?</p>
                <div className="flex justify-between p-4">
                  <button className="inline-block rounded-[18px] border border-red-200 bg-gradient-to-r from-red-500 to-rose-500 px-4 py-3 text-sm font-semibold text-white shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md" onClick={handleLogout}>Fortsätt</button>
                  <button className="inline-block rounded-[18px] border border-slate-200 bg-slate-100 px-4 py-3 text-sm font-semibold text-slate-700 shadow-sm transition-colors hover:bg-slate-200" onClick={() => setModalIsOpen(false)}>Avbryt</button>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
}

export default MyPage;
